import React, { FC } from 'react';

import { withTheme } from '@emotion/react';
import styled from '@emotion/styled';

import Heading, { HeadingProps } from '../heading/heading';
import Text, { TextProps } from '../text/text';

interface CardSubtitleProps {
  isText?: boolean;
}

type CardSubtitlePropsType = CardSubtitleProps & (HeadingProps | TextProps);

const HeadingCardSubtitle = styled(Heading)({
  label: 'headingCardSubtitle'
});

const TextCardSubtitle = styled(Text)({
  label: 'textCardSubtitle'
});

const Subtitle: FC<CardSubtitlePropsType> = ({ isText = false, ...rest }: CardSubtitleProps) => {
  return isText ? <TextCardSubtitle {...rest} /> : <HeadingCardSubtitle {...rest} />;
};

const CardSubtitle = withTheme(Subtitle);

export { CardSubtitle };
export default CardSubtitle;
